var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"toast-container position-fixed bottom-0 start-50 translate-middle-x mb-2"},[_c('transition-group',{attrs:{"name":"toast","tag":"div"}},_vm._l((_vm.toasts),function(toast,index){return _c('Toast',{key:toast.addedMS,attrs:{"toast":toast,"index":index}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }